import Client from './Client'
import { Error } from './Error'

export default class Webhook extends Client {
  async fetchWebhooks(token) {
    try {
      return await this.request(token, 'get', 'webhook', null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async deleteWebhook(token, id) {
    try {
      return await this.request(token, 'delete', `webhook/${id}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async updateWebhook(token, id, body) {
    try {
      return await this.request(token, 'post', `webhook/${id}`, body, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async createWebhook(token, body) {
    try {
      return await this.request(token, 'post', 'webhook', body, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
